<template>
  <!-- <div v-if="WXTest&&wxconfig.appid">
    <wx-open-launch-app
      class="sticky"
      @error="handleError"
      @launch="handleLaunch"
      :appid="wxconfig.appid"
    >
      <script type="text/wxtag-template">
        <style>.btn { color: #fff; font-size: 10px; text-align:center; line-height:23px}
        </style>
         <div class="btn">打开</div>
      </script>
      </script>
    </wx-open-launch-app>
  </div> -->
  <div  class="sticky" @click="$emit('click')">
    <div class="sticky_center">
      <div class="left">
        <img src="../../assets/image/community/logo.png" class="c-img" />
        <div class="right">
          <div>39游戏盒子</div>
          <div>重温千年情怀，找回年少的自己</div>
        </div>
      </div>
      <div class="sticky_but">立即下载</div>
    </div>
  </div>
</template>

<script>
import { WXTest } from "@/utils/guidance";
import { mapState } from "vuex";
export default {
  data() {
    return {
      WXTest,
    };
  },
  computed: {
    ...mapState({
      wxconfig: (state) => state.init.wxconfig,
    }),
  },
  methods: {
    handleLaunch() {
      console.log("换起了");
    },
    handleError() {
      console.log("失败了");
    },
  },
};
</script>

<style lang="scss" scoped>
.sticky {
  position: sticky;
  top: 0;
  height: 1.466667rem /* 110/75 */;
  background: #c1a673;
  display: flex;
  align-items: center;
  padding: 0 0.8rem /* 60/75 */ 0 0.613333rem /* 46/75 */;
  box-sizing: border-box;
  z-index: 9;

  .sticky_center {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left {
      display: flex;
      align-items: center;
      font-size: 0.373333rem /* 28/75 */;
      color: #ffffff;
      .right {
        color: #fff;
        > div:nth-child(1) {
          font-size: 0.373333rem /* 28/75 */;

          font-weight: bold;
        }
        > div:nth-child(2) {
          padding-top: 0.04rem /* 3/75 */;
          font-size: 0.32rem /* 24/75 */;
        }
      }
      .c-img {
        width: 0.96rem /* 72/75 */;
        height: 0.96rem /* 72/75 */;
        border-radius: 0.213333rem /* 16/75 */;
        overflow: hidden;
        margin-right: 0.346667rem /* 26/75 */;
      }
    }
    .sticky_but {
      width: 2.026667rem /* 152/75 */;
      height: 0.746667rem /* 56/75 */;
      border-radius: 0.453333rem /* 34/75 */;
      background: #fff;
      color: #8e703a;
      font-size: 0.373333rem /* 28/75 */;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
